import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TimeCardJobComponent } from './time-card-job/time-card-job.component';


const routes: Routes = [
  { path: '', component: TimeCardJobComponent }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class TimeCardRoutingModule { }
